/**
 * DataAPIでテンプレートを再構築します。
 *
 * @param {Object} options - 設定オブジェクト
 * @param {Number} options.siteId - サイトID
 * @param {Number} options.templateId - テンプレートID
 * @param {Number} options.templateName - テンプレート名
 * @param {Boolean} [options.noConfirm=false] - trueを設定すると確認画面を表示しない
 */
import { getDataApiUrl } from './getDataApiUrl.js';
import { msg } from './msg.js';
import { modalConfirm } from './modalConfirm.js';

export async function rebuildTemplate(options) {
    const op = {
        siteId: 0,
        templateId: 0,
        templateName: '',
        noConfirm: false,
        ...options
    };

    if (!op.siteId) {
        return alert('The siteId option is required.');
    }
    if (!op.templateName && !op.templateId) {
        return alert('The templateId option is required.');
    }

    const dataApiUrl = getDataApiUrl();
    try {
        // テンプレートIDが指定されていなくテンプレート名が指定されている場合は、まずテンプレートIDを取得
        if (typeof op.templateName === 'string' && op.templateName && op.templateId === 0) {
            const response = await fetch(`${dataApiUrl}/sites/${op.siteId}/templates?limit=1000`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.totalResults === 0) {
                throw new Error(`${op.templateName} is not found.`);
            }

            const template = data.items.find((t) => t.name === op.templateName);
            if (!template) {
                throw new Error('The templateName option is invalid.');
            }

            op.templateId = template.id;
        }

        // テンプレートデータを取得
        const templateResponse = await fetch(`${dataApiUrl}/sites/${op.siteId}/templates/${op.templateId}`);

        if (!templateResponse.ok) {
            throw new Error(`HTTP error! status: ${templateResponse.status}`);
        }

        const template = await templateResponse.json();
        const templateName = template.name;

        const rebuild = async function () {
            try {
                // テンプレートを再構築
                const publishResponse = await fetch(`${dataApiUrl}/sites/${op.siteId}/templates/${op.templateId}/publish`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: '{}'
                });

                if (!publishResponse.ok) {
                    throw new Error(`HTTP error! status: ${publishResponse.status}`);
                }

                const result = await publishResponse.json();

                if (result.status === 'success') {
                    msg({
                        type: 'success',
                        msg: `「${templateName}」を再構築しました。`,
                        dismissible: true
                    });
                }
            } catch (error) {
                console.error('Template publish error:', error);
                msg({
                    type: 'error',
                    msg: `テンプレートの再構築に失敗しました: ${error.message}`,
                    dismissible: true
                });
            }
        };

        if (op.noConfirm) {
            await rebuild();
        } else {
            modalConfirm({
                type: 'warning',
                title: 'テンプレート再構築',
                content: `「${templateName}」を再構築しますか？`,
                okButtonLabel: '再構築',
                cancelButtonLabel: 'キャンセル',
                callback: rebuild
            });
        }
    } catch (error) {
        console.error('Template operation error:', error);
        msg({
            type: 'error',
            msg: `テンプレート操作に失敗しました: ${error.message}`,
            dismissible: true
        });
    }
}
